import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  Button,
} from '@org/ui';
import { useTranslation } from 'react-i18next';

/**
 * Shown when the admin leaves a step of a multi-step form with edits that
 * were not saved yet. Three ways out: save and go, drop the edits and go,
 * or stay.
 */
export function UnsavedChangesDialog({
  open,
  onSave,
  onDiscard,
  onCancel,
  saving = false,
}: {
  open: boolean;
  onSave: () => void;
  onDiscard: () => void;
  onCancel: () => void;
  saving?: boolean;
}) {
  const { t } = useTranslation('admin');
  return (
    <AlertDialog open={open} onOpenChange={(next) => !next && onCancel()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t('common.unsavedChanges.title')}</AlertDialogTitle>
          <AlertDialogDescription>{t('common.unsavedChanges.body')}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onCancel}>{t('common.unsavedChanges.cancel')}</AlertDialogCancel>
          <Button type="button" variant="outline" onClick={onDiscard} disabled={saving}>
            {t('common.unsavedChanges.discard')}
          </Button>
          <AlertDialogAction onClick={(e) => { e.preventDefault(); onSave(); }} disabled={saving}>
            {t('common.unsavedChanges.save')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
